import styled from 'styled-components'

import { minmedia, maxmedia } from '../../styles/media-queries'
import { white, bordergray, inputgray, almostblack, darkblue, black } from '../../styles/colors'

export const Container = styled.div`
  position: relative;
`

export const Bar = styled.div`
  padding: 0 1.5rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  ${maxmedia.large`
    display: none;
  `};
`

export const BarItem = styled.div`
  width: calc(25% - 1rem);
  color: ${props => (props.dark ? almostblack : white)};
  text-transform: uppercase;
  font-weight: 400;
  font-size: 14px;
`

export const Branch = styled.div`
  transition: all 0.5s;
  position: relative;
  background: ${props => (props.selected ? darkblue : white)};
  border-radius: 0.25rem;
  border: ${props => (props.selected ? 0 : `1px solid ${bordergray}`)};
  padding: 0.75rem 1rem;
  margin-bottom: 0.5rem;
  color: ${props => (props.selected ? white : black)}
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  cursor: ${props => (props.selected ? 'normal' : 'pointer')};

  &:hover {
    background: ${props => (props.selected ? darkblue : bordergray)};
  }

  ${minmedia.medium`
    padding: 1rem 1.5rem;
  `} ${minmedia.large`
    padding: 1.25rem 1.5rem;
    margin-bottom: 0.25rem;
  `};
`

export const MetaContainer = styled.div`
  width: 100%;
  margin: 0.35rem 0;

  ${minmedia.medium`
    width: calc(50% - 1rem);
    margin: .75rem 0;
  `} ${minmedia.large`
    width: calc(25% - 1rem);
    margin: 0;
  `};
`

export const Meta = styled.div``

export const Sup = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${props => (props.selected ? white : inputgray)};
  text-transform: uppercase;
  margin-bottom: 0.35rem;
  display: none;

  ${minmedia.medium`
    display: block;
  `} ${minmedia.large`
    display: none;
  `};
`

export const IconContainer = styled.div`
  display: none;
`



// WEBPACK FOOTER //
// ./src/containers/BrancheList/styles.js